<div
  class="collapse"
  [ngClass]="{
    'collapse--card': styles?.isCard,
    'collapse--rounded': styles?.isRounded,
    'collapse--open': showContent || forceShowContent
  }">
  <div
    class="collapse-ee-header"
    (click)="toggleCollapsible()"
    *ngIf="!forceShowContent"
  >
    <div class="collapse-ee-title">
      <ng-content
        class="collapse-ee-title-text"
        select=".collapse-header">
      </ng-content>
    </div>
    <span
      *ngIf="!hideButton"
      class="collapse-ee-button"
      [ngClass]="{ 'collapse-ee-button--opened': showContent }"
    ></span>
  </div>
  <div
    class="collapse-ee-body"
    *ngIf="showContent || forceShowContent"
    [@inOutAnimation]="{ value: 'open', params: { time: styles?.animationDuration || 350 }}"
    >
    <div class="collapse-ee-body-content">
      <ng-content select=".collapse-body"></ng-content>
    </div>
  </div>
</div>
